import { render, staticRenderFns } from "./MinimumQuantityTable.vue?vue&type=template&id=1438c7d8&scoped=true&"
import script from "./MinimumQuantityTable.vue?vue&type=script&lang=js&"
export * from "./MinimumQuantityTable.vue?vue&type=script&lang=js&"
import style0 from "./MinimumQuantityTable.vue?vue&type=style&index=0&id=1438c7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438c7d8",
  null
  
)

export default component.exports